import { setAccessToken, setLoginStatus } from "actions/user";
import { takeLeading, put } from "redux-saga/effects";
import { post } from "sagas/helpers/network";
import { AccessTokenKey } from "constants/keys";

function* execute(action: sage.actions.user.ILogin) {
    yield put(setLoginStatus("loading"));
    try {
        const response = yield post("/login", {
            email: action.email,
            password: action.password,
        });
        if (response.data && response.data.access_token) {
            localStorage.setItem(AccessTokenKey, response.data.access_token);
            yield put(setAccessToken(response.data.access_token));
        } else {
            yield put(setLoginStatus("error"));
        }
    } catch (e) {
        if (
            e.response &&
            e.response.data &&
            e.response.data.error === "UNAUTHENTICATED_ERROR"
        ) {
            yield put(setLoginStatus("unauthorized"));
        } else {
            yield put(setLoginStatus("error"));
        }
    }
}

export default function* saga(): Generator {
    yield takeLeading("com.sage.actions.user.ILogin", execute);
}
